import { render, staticRenderFns } from "./TagsCell.vue?vue&type=template&id=38d34466&scoped=true&"
import script from "./TagsCell.vue?vue&type=script&lang=ts&"
export * from "./TagsCell.vue?vue&type=script&lang=ts&"
import style0 from "./TagsCell.vue?vue&type=style&index=0&id=38d34466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d34466",
  null
  
)

export default component.exports